import myAxios from "@/request";

/**
 * 用户注册
 * @param params
 */
interface EnterprisesRegisterRequest {
  enterprise_account: string;
  enterprise_password: string;
  check_password: string;
  enterprise_name: string;
  enterprise_code: string;
  email: string;
  phone: string;
}

export const enterprisesRegister = async (
  params: EnterprisesRegisterRequest
) => {
  return await myAxios.request({
    url: "/enterprise/register",
    method: "POST",
    data: params,
  });
};

/**
 * 用户登录
 * @param params
 */
interface EnterprisesLoginRequest {
  enterprise_account: string;
  enterprise_password: string;
}

export const enterprisesLogin = async (params: EnterprisesLoginRequest) => {
  return await myAxios.request({
    url: "/enterprise/login",
    method: "POST",
    data: params,
  });
};

/**
 * 用户登出
 * @param params
 */
export const enterprisesLogout = async (params: any) => {
  return await myAxios.request({
    url: "/enterprise/logout",
    method: "POST",
    data: params,
  });
};

/**
 * 用户信息获取
 * @param params
 */
export const getEnterprisesInfo = async () => {
  return await myAxios.request({
    url: "/enterprise/getInfo",
    method: "GET",
  });
};

/**
 * 用户信息设置
 * @param params
 */

interface EnterprisesSetInfoRequest {
  enterprise_name: string;
  logo: string;
  phone: string;
  email: string;
  address: string;
  website: string;
  description: string;
}

export const setEnterprisesInfo = async (params: EnterprisesSetInfoRequest) => {
  return await myAxios.request({
    url: "/enterprise/setInfo",
    method: "POST",
    data: params,
  });
};

// 创建项目请求接口
export interface ProjectsCreateRequest {
  project_name: string;
  project_description: string;
}

// 创建项目
interface ProjectsCreateResponse {
  code: number;
  message: string;
  data: number; // 返回项目ID
}

export const createProject = async (
  params: ProjectsCreateRequest
): Promise<ProjectsCreateResponse> => {
  return await myAxios.request({
    url: "/projects/create",
    method: "POST",
    data: params,
  });
};

// 删除项目请求接口
export interface ProjectsDeleteRequest {
  projectId: number;
}

// 删除项目
interface ProjectsDeleteResponse {
  code: number;
  message: string;
  data: boolean; // 返回是否删除成功
}

export const deleteProject = async (
  params: ProjectsDeleteRequest
): Promise<ProjectsDeleteResponse> => {
  return await myAxios.request({
    url: "/projects/delete",
    method: "POST",
    data: params,
  });
};

// 获取项目列表
interface ProjectsListResponse {
  code: number;
  message: string;
  data: Array<{
    id: number;
    project_name: string;
    project_description: string;
    project_status: string;
    created_at: string;
    updated_at: string;
    total_contribution: number;
    real_contribution: number;
  }>;
}

export const getProjectsList = async (): Promise<ProjectsListResponse> => {
  return await myAxios.request({
    url: "/projects/list",
    method: "GET",
  });
};

// 获取所有公开项目
interface ProjectsPublicListResponse {
  code: number;
  message: string;
  data: Array<{
    id: number;
    enterprise_id: number;
    project_name: string;
    project_description: string;
    project_status: string;
    total_contribution: number;
    real_contribution: number;
    project_teamSize: number; // 项目成员数量
    project_enterpriseName: string; // 项目企业名称
    created_at: string;
    updated_at: string;
  }>;
}

export const getAllProjects = async (): Promise<ProjectsPublicListResponse> => {
  return await myAxios.request({
    url: "/projects/public-list",
    method: "GET",
  });
};

// 申请参与项目
interface ProjectsApplyResponse {
  code: number;
  message: string;
  data: boolean;
}

export const applyProject = async (
  projectId: number
): Promise<ProjectsApplyResponse> => {
  return await myAxios.request({
    url: `/projects/${projectId}/apply`,
    method: "POST",
  });
};

// 检查项目状态
interface ProjectsStatusResponse {
  code: number;
  message: string;
  data: boolean;
}

export const checkProjectStatus = async (
  projectId: number
): Promise<ProjectsStatusResponse> => {
  return await myAxios.request({
    url: `/projects/${projectId}/check-status`,
    method: "GET",
  });
};

// 获取用户项目列表
interface UserProjectsResponse {
  code: number;
  message: string;
  data: Array<{
    id: number;
    project_name: string;
    project_description: string;
    project_status: string;
    total_contribution: number;
    real_contribution: number;
    created_at: string;
    updated_at: string;
    project_teamSize: number;
    project_enterpriseName: string;
  }>;
}

export const getUserProjects = async (): Promise<UserProjectsResponse> => {
  return await myAxios.request({
    url: "/projects/user-projects",
    method: "GET",
  });
};

// 获取用户在项目中的贡献值
interface UserContributionResponse {
  code: number;
  message: string;
  data: number;
}

export const getUserProjectContribution = async (
  projectId: number
): Promise<UserContributionResponse> => {
  return await myAxios.request({
    url: `/projects/${projectId}/user-contribution`,
    method: "GET",
  });
};

// 项目成员DTO
interface ProjectMemberDTO {
  userId: number;
  userName: string;
  role: string;
  joinAt: string;
  totalContribution: number;
}

// 获取项目成员列表响应
interface ProjectMembersResponse {
  code: number;
  message: string;
  data: Array<ProjectMemberDTO>;
}

// 获取项目成员列表
export const getProjectMembers = async (
  projectId: number
): Promise<ProjectMembersResponse> => {
  return await myAxios.request({
    url: `/projects/${projectId}/members`,
    method: "GET",
  });
};

// 任务相关API
// 任务DTO
interface TaskDTO {
  id: number;
  title: string;
  description: string;
  status: "todo" | "in_progress" | "review" | "completed";
  createdAt: string;
  deadline: string;
  assignee_id: number;
  contribution: number;
  project_id: number;
}

// 任务用户分配DTO
interface TaskUserDTO {
  task_id: number;
  user_id: number;
  contribution: number;
}

// 创建任务请求
interface CreateTaskRequest {
  task: TaskDTO;
  taskUsers: Array<TaskUserDTO>;
}

// 任务响应
interface TaskResponse {
  code: number;
  message: string;
  data: boolean;
}

// 任务列表响应
interface TaskListResponse {
  code: number;
  message: string;
  data: Array<TaskDTO>;
}

// 创建任务
export const createTask = async (
  projectId: number,
  request: CreateTaskRequest
): Promise<TaskResponse> => {
  return await myAxios.request({
    url: `/tasks/projects/${projectId}/tasks`,
    method: "POST",
    data: request,
  });
};

// 获取项目任务列表
export const getProjectTasks = async (
  projectId: number
): Promise<TaskListResponse> => {
  return await myAxios.request({
    url: `/tasks/projects/${projectId}/tasks`,
    method: "GET",
  });
};

// 完成任务
export const completeTask = async (taskId: number): Promise<TaskResponse> => {
  return await myAxios.request({
    url: `/tasks/${taskId}/complete`,
    method: "POST",
  });
};

// 更新任务
export const updateTask = async (
  taskId: number,
  request: CreateTaskRequest
): Promise<TaskResponse> => {
  return await myAxios.request({
    url: `/tasks/${taskId}`,
    method: "PUT",
    data: request,
  });
};

// 删除任务
export const deleteTask = async (taskId: number): Promise<TaskResponse> => {
  return await myAxios.request({
    url: `/tasks/${taskId}`,
    method: "DELETE",
  });
};

// 获取任务贡献者列表
export const getTaskUsers = async (
  taskId: number
): Promise<{
  code: number;
  message: string;
  data: Array<{
    id: number;
    task_id: number;
    user_id: number;
    contribution: number;
    created_at: string;
    updated_at: string;
  }>;
}> => {
  return await myAxios.request({
    url: `/tasks/${taskId}/users`,
    method: "GET",
  });
};
